import { combineReducers } from 'redux';

import app from './app';
import home from './home';
import blog from './blog';

const rootReducer = combineReducers({
    app,
    home,
    blog,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/index.js